import type { SVGProps } from 'react';
const SvgChromeReaderMode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#chrome_reader_mode_svg__a)">
      <path
        fill="currentColor"
        d="M13 12h7v1.5h-7V12Zm0-2.5h7V11h-7V9.5Zm0 5h7V16h-7v-1.5ZM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 15h-9V6h9v13Z"
      />
    </g>
    <defs>
      <clipPath id="chrome_reader_mode_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChromeReaderMode;
